export const questionAnsList_style = {
  cardRootSx: {
    border: '1px solid #EEEEEE',
    borderRadius: '8px',
    p: 2,
    mb: 1,
    bgcolor: '#fff',
  },
};
